// 合约模块
const verify = {
    path: 'contract',
    component: () => import('@/components/RouterView'),
    meta: {title: '认证/签约'},
    children: [
        {
            path: 'verify',
            component: () => import('@/components/RouterView'),
            meta: {title: '认证'},
            children: [
                {
                    path: 'fdd',
                    component: () => import('@/components/RouterView'),
                    meta: {title: '法大大'},
                    children: [
                        {
                            path: 'step/1',
                            component: () => import('@/views/contract/verify/fdd/step1.vue'),
                            meta: {title: '实名认证'},
                        },
                        {
                            path: 'step/2',
                            component: () => import('@/views/contract/verify/fdd/step2.vue'),
                            meta: {title: '合同签署'},
                        },
                        {
                            path: 'step/3',
                            component: () => import('@/views/contract/verify/fdd/step3.vue'),
                            meta: {title: '认证状态'},
                        },
                    ],
                },
                {
                    path: 'dzq',
                    component: () => import('@/components/RouterView'),
                    meta: {title: '电子签'},
                    children: [
                        {
                            path: 'step/1',
                            component: () => import('@/views/contract/verify/dzq/step1.vue'),
                            meta: {title: '实名认证-电子签'},
                        },
                        {
                            path: 'step/2',
                            component: () => import('@/views/contract/verify/dzq/step2.vue'),
                            meta: {title: '合同签署-电子签'},
                        },
                        {
                            path: 'step/3',
                            component: () => import('@/views/contract/verify/dzq/step3.vue'),
                            meta: {title: '认证状态-电子签'},
                        },
                    ],
                },
            ],
        },
        {
            path: 'update',
            component: () => import('@/components/RouterView'),
            meta: {title: '更新认证'},
            children: [
                {
                    path: 'fdd',
                    component: () => import('@/components/RouterView'),
                    meta: {title: '法大大'},
                    children: [
                        {
                            path: 'name',
                            component: () => import('@/views/contract/update/fdd/name.vue'),
                            meta: {title: '修改姓名'},
                        },
                        {
                            path: 'phone',
                            component: () => import('@/views/contract/update/fdd/phone.vue'),
                            meta: {title: '修改手机号'},
                        },
                    ],
                },
                {
                    path: 'dzq',
                    component: () => import('@/components/RouterView'),
                    meta: {title: '电子签'},
                    children: [
                        {
                            path: 'name',
                            component: () => import('@/views/contract/update/dzq/name.vue'),
                            meta: {title: '修改姓名'},
                        },
                        {
                            path: 'phone',
                            component: () => import('@/views/contract/update/dzq/phone.vue'),
                            meta: {title: '修改手机号'},
                        },
                    ],
                },
            ],
        },
        {
            path: 'enterprise',
            component: () => import('@/components/RouterView'),
            meta: {title: '升级企业'},
            children: [
                {
                    path: 'fdd',
                    component: () => import('@/components/RouterView'),
                    meta: {title: '法大大'},
                    children: [
                        {
                            path: 'signContract',
                            component: () => import('@/views/contract/enterprise/fdd/signContract'),
                            meta: {title: '合同签署'},
                        },
                        {
                            path: '',
                            component: () => import('@/views/contract/enterprise/fdd'),
                            meta: {title: '认证并升级'},
                        },
                        {
                            path: 'qualification',
                            component: () => import('@/views/contract/enterprise/fdd/qualification'),
                            meta: {title: '企业资质'},
                        },
                    ],
                },
                {
                    path: 'dzq',
                    component: () => import('@/components/RouterView'),
                    meta: {title: '电子签'},
                    children: [
                        {
                            path: '',
                            component: () => import('@/views/contract/enterprise/dzq'),
                            meta: {title: '升级为企业'},
                        },
                        {
                            path: 'signContract',
                            component: () => import('@/views/contract/enterprise/dzq/signContract'),
                            meta: {title: '合同签署'},
                        },
                        {
                            path: 'authentication',
                            component: () => import('@/views/contract/enterprise/dzq/authentication'),
                            meta: {title: '认证并升级'},
                        },
                        {
                            path: 'qualification',
                            component: () => import('@/views/contract/enterprise/dzq/qualification'),
                            meta: {title: '企业资质'},
                        },
                    ],
                },
            ],
        },
        {
            path: 'distribute',
            component: () => import('@/components/RouterView'),
            meta: {title: '分账详情'},
            children: [
                {
                    path: 'fdd',
                    component: () => import('@/components/RouterView'),
                    meta: {title: '法大大'},
                    children: [
                        {
                            path: 'signContract',
                            component: () => import('@/views/contract/distribute/fdd/signContract'),
                            meta: {title: '合同签署'},
                        },
                    ],
                },
                {
                    path: 'dzq',
                    component: () => import('@/components/RouterView'),
                    meta: {title: '电子签'},
                    children: [
                        {
                            path: 'signContract',
                            component: () => import('@/views/contract/distribute/dzq/signContract'),
                            meta: {title: '合同签署'},
                        },
                    ],
                },
            ],
        },
    ],
};

export default verify;
